import { render, staticRenderFns } from "./RatingMessage.vue?vue&type=template&id=9a72a672&scoped=true&"
import script from "./RatingMessage.vue?vue&type=script&lang=js&"
export * from "./RatingMessage.vue?vue&type=script&lang=js&"
import style0 from "./RatingMessage.vue?vue&type=style&index=0&id=9a72a672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a72a672",
  null
  
)

export default component.exports